/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Home_Meta_DescriptionInputs */

const es_home_meta_description = /** @type {(inputs: Home_Meta_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Conecta tus herramientas, centraliza tu informacion empresarial y obtiene respuestas inteligentes al instante con Nexata.`)
};

const en_home_meta_description = /** @type {(inputs: Home_Meta_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Connect your tools, centralize your enterprise knowledge, and get smart answers instantly with Nexata.`)
};

/**
* | output |
* | --- |
* | "Connect your tools, centralize your enterprise knowledge, and get smart answers instantly with Nexata." |
*
* @param {Home_Meta_DescriptionInputs} inputs
* @param {{ locale?: "es" | "en" }} options
* @returns {LocalizedString}
*/
const home_meta_description = /** @type {((inputs?: Home_Meta_DescriptionInputs, options?: { locale?: "es" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Home_Meta_DescriptionInputs, { locale?: "es" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_home_meta_description(inputs)
	return en_home_meta_description(inputs)
});
export { home_meta_description as "home.meta.description" }